/** Bare `X.Y.Z` semver helpers for release-notes versions (no `v`, no
 *  pre-release tags — the release workflow only ever cuts plain versions). */
export type Semver = readonly [number, number, number];

const SEMVER_RE = /^(\d+)\.(\d+)\.(\d+)$/;

export function parseSemver(v: string): Semver | null {
    const m = SEMVER_RE.exec(v.trim());
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
}

/** Sort-comparator sign (a − b). Unparseable versions compare as 0.0.0. */
export function compareSemver(a: string, b: string): number {
    const pa = parseSemver(a) ?? [0, 0, 0];
    const pb = parseSemver(b) ?? [0, 0, 0];
    for (let i = 0; i < 3; i++) {
        if (pa[i] !== pb[i]) return pa[i] - pb[i];
    }
    return 0;
}

/** Releases cut from main are minor bumps: 0.18.x → 0.19.0. */
export function nextMinor(v: string): string {
    const p = parseSemver(v);
    if (!p) throw new Error(`not a bare semver version: ${v}`);
    return `${p[0]}.${p[1] + 1}.0`;
}
